import { create } from 'zustand';

import {
  IAddToDefaultPhoneNumber,
  IIsSheetOpen,
  IRefetchUserInfo,
  ISecurityMenu,
} from './interface';

export { useCustomerInfoStore } from '@shared/store';

export const useRefetchUserInfo = create<IRefetchUserInfo>((set) => ({
  refetchUserInfo: false,
  setRefetchUserInfo: (data) => {
    set({ refetchUserInfo: data });
  },
}));

export const useAddToDefaultPhoneNumber = create<IAddToDefaultPhoneNumber>((set) => ({
  addToDefaultPhoneNumber: false,
  setAddToDefaultPhoneNumber: (data) => {
    set({ addToDefaultPhoneNumber: data });
  },
}));

export const useIsSheetOpen = create<IIsSheetOpen>((set) => ({
  IsSheetOpen: false,
  setIsSheetOpen: (data) => {
    set({ IsSheetOpen: data });
  },
}));
